import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-skeleton-grafica',
  templateUrl: './skeleton-grafica.component.html',
  styleUrl: './skeleton-grafica.component.css'
})
export class SkeletonGraficaComponent {
  @Input() barras: number = 7;
  @Input() leyendas: number = 3;

  get barrasArray() { return Array(this.barras).fill(0); }
  get leyendasArray() { return Array(this.leyendas).fill(0); }

  alturas = [65, 85, 45, 95, 55, 75, 40, 88, 60, 70];
  delays  = [0, 80, 160, 40, 120, 200, 60, 140, 20, 180];

  getAltura(i: number) { return this.alturas[i % this.alturas.length]; }
  getDelay(i: number)  { return this.delays[i % this.delays.length] + 'ms'; }
}
